/**
 * The fragment id an article heading is given, from its text, so a link can open the article at
 * that section.
 *
 * The article view gives each heading this id, and an assistant citation of a section links to it
 * (#6019). Both read it from the heading's words: RAG records the heading as Markdown source and the
 * view renders it, so markup that renders as nothing - `**`, `_`, backticks - must not change the
 * id. Lower case, letters and digits kept in any script, every other run of characters one hyphen.
 * Undefined for a heading with no letters or digits, which has nothing to link by.
 */
export default function articleHeadingAnchor(heading: string | undefined): string | undefined {
  const anchor = (heading ?? "")
    .normalize("NFKC")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-+|-+$/g, "");
  return anchor ? `section-${anchor}` : undefined;
}
